export default __webpack_public_path__ + "static/media/BusinessConsultingLebenswerkBusinessManagement4.3ca6e468.png";